import React from "react";
import { ImPointRight } from "react-icons/im";

export default function Achievements() {
  const data = [
    {
      txt: "Awarded 1st Prize in the Smart Education Domain at the EPITOME'24 Hackathon conducted by GSDC,GRIET",
      doc: "https://drive.google.com/file/d/1jPjzG4eViJAEgKZeaJsTvFPMDnr03ju9",
    },
    {
      txt: "Awarded 2nd prize in the travel and tourism Domain at the Vivitsu'24 hackathon conducted by FSW,GRIET",
      doc: "",
    },
    {
      txt: "Honorable Mention for InnerSerenity in the AWS Honorable Mentions category at the AWS Fantom Hackathon Q2 2023",
      doc: "https://devpost.com/software/innerserenity-fantom-aws-empowering-inner-peace",
    },
    {
      txt: "Certificate of completion of Database Programming with SQL course offered by Oracle Academy",
      doc: "https://drive.google.com/file/d/1NUIVpst9DetJgjw5w57U3-pd66Lh2cAL/",
    },
    {
      txt: "Certificate of completion of Database Design course offered by Oracle Academy",
      doc: "https://drive.google.com/file/d/1k9gbaG4JnZ56jr8pwY0b6I9-pdSRZ14w/",
    },
  ];
  return (
    <>
      <div>
        {data.map((dat, index) => {
          return (
            <div key={index} className="d-flex gap-2 justify-content-center">
              <ImPointRight />
              <p>{dat.txt}</p>
              <a
                style={{ zIndex: "9999" }}
                className="text-light"
                href={dat.doc}
                target="_blank"
              >
                (view)
              </a>
            </div>
          );
        })}
      </div>
    </>
  );
}
